module.exports = __webpack_public_path__ + "media/music/drumkit_7-19b4d90f.mp3";